import Vue from 'vue'
import Vuex from 'vuex'
import ajax from '../utils/request';
import Cookies from "js-cookie";
import { Notification } from "element-ui";

Vue.use(Vuex)

function createStore() {
    return new Vuex.Store({
        state: {
            order_id: '',
            medicine_order: {},
            order_products: [],
            productform: {
                mchid: ''
            },
            productlist: [],
            upload_pic: [],
        },
        mutations: {
            order_id(state, order_id) {
                state.order_id = order_id;
            },
            productform(state, productform) {
                state.productform = productform
            },
            get_order_model(state, order_id) {
                ajax.get(Vue.prototype.$api + '/consultation_room/get_order_model', { order_id: order_id })
                    .then((res) => {
                        if (res.code === 0) {
                            state.medicine_order = res.data.medicine_order
                            state.medicine_order.lv1_name = res.data.mch_attr.lv1_name
                            state.medicine_order.lv2_name = res.data.mch_attr.lv2_name
                            state.medicine_order.lv3_name = res.data.mch_attr.lv3_name
                            state.medicine_order.name = res.data.mch_attr.name
                            state.productform.mchid = res.data.medicine_order.mchid
                            state.order_products = res.data.product_list
                        } else {
                            Notification({
                                title: '失败',
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    })
            },
            get_product(state) {
                ajax.post(Vue.prototype.$api + '/consultation_room/get_product', state.productform)
                    .then((res) => {
                        if (res.code === 0) {
                            state.productlist = res.data
                        } else {
                            Notification({
                                title: '失败',
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    })
            },
            get_upload_pic(state, order_id) {
                ajax.noloadingget(Vue.prototype.$api + '/consultation_room/get_upload_pic', { order_id: order_id })
                    .then((res) => {
                        if (res.code === 0) {
                            state.upload_pic = res.data.upload_pic_array
                        } else {
                            Notification({
                                title: '失败',
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    })
            },
            calling_end(state) {
                state.order_id = '';
                state.medicine_order = {};
                state.order_products = [];
                state.productform = {};
                state.productlist = [];
                state.upload_pic = [];
                ajax.noloadingget(Vue.prototype.$api + '/consultation_room/change_my_state', { remote_state: 1 })
            }
        }
    });
}

const store = createStore();
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js